import { ColumnSpanConfig } from "./GridColumn.types";

// Shared span presets, so a width means the same thing on every page. Each
// narrows toward full width on smaller screens rather than staying in columns.

/** Field spans, within a section's own 12-column row. */
export const fullWidth: ColumnSpanConfig = {
  desktop: 12,
  tablet: 12,
  mobile: 12,
};
export const halfWidth: ColumnSpanConfig = {
  desktop: 6,
  tablet: 6,
  mobile: 12,
};
export const thirdWidth: ColumnSpanConfig = {
  desktop: 4,
  tablet: 6,
  mobile: 12,
};
export const quarterWidth: ColumnSpanConfig = {
  desktop: 3,
  tablet: 6,
  mobile: 12,
};
